<div class="sdp-name-change">
	<h3 class="sdp-header-no-margin-top">{{ "name-change.title" | translate }}</h3>
	<div class="sdp-section-header-description">
		{{ "name-change.description" | translate }}
	</div>

	<form
		[formGroup]="nameChangeForm"
		(ngSubmit)="submit()"
		novalidate
	>
		<div class="sdp-name-change-form">
			<div class="sdp-form-control">
				<mat-form-field class="sdp-form-control-input-container">
					<input
						matInput
						placeholder="{{ 'form.label.firstname' | translate }}"
						type="text"
						formControlName="firstName"
					>
					<mat-error *ngIf="nameChangeForm.controls['firstName'].hasError('required')">{{ "error.message.firstName.required" | translate }}</mat-error>
				</mat-form-field>
			</div>
			<div class="sdp-form-control">
				<mat-form-field class="sdp-form-control-input-container">
					<input
						matInput
						placeholder="{{ 'form.label.lastname' | translate }}"
						type="text"
						formControlName="lastName"
					>
					<mat-error *ngIf="nameChangeForm.controls['lastName'].hasError('required')">{{ "error.message.lastName.required" | translate }}</mat-error>
				</mat-form-field>
			</div>
			<div class="sdp-form-control sdp-buttons">
				<button
					mat-raised-button
					color="primary"
					type="submit"
				>{{ "sdp.label.update" | translate }}</button>
			</div>
		</div>
	</form>
	<mat-progress-bar
		mode="indeterminate"
		*ngIf="!isDataLoaded"
		class="sdp-progress-bar"
	></mat-progress-bar>

</div>